module.exports = __webpack_public_path__ + "img/ch.fda09c52.svg";